export default "__VITE_ASSET__7a70bbe2__"